/*
 * Plain strings, posted by the `fetch` helper in `client.ts`.
 *
 * No Apollo Client, no `graphql-tag`: the widget issues eight operations, has no
 * cache to normalize and no subscriptions — an open panel re-asks two of these
 * on a timer instead (`usePolling`) — and every kilobyte here is paid by every
 * visitor of every publisher's page.
 */

export const START_WIDGET_SESSION = `
  mutation StartWidgetSession($input: StartWidgetSessionInput!) {
    startWidgetSession(input: $input) {
      sessionToken
      contact { id name email }
    }
  }
`;

export const MY_TICKETS = `
  query MyTickets {
    myTickets { id number title status lastMessageAt unread }
  }
`;

export const TICKET_MESSAGES = `
  query TicketMessages($ticketId: ID!) {
    ticketMessages(ticketId: $ticketId) {
      id body authorKind authorName createdAt
      attachments { id name mimeType size }
    }
  }
`;

/**
 * `TICKET_MESSAGES` as the API knew it before attachments. Sent only to an API
 * that does not know the current one — see `compat.ts`.
 */
export const TICKET_MESSAGES_WITHOUT_ATTACHMENTS = `
  query TicketMessages($ticketId: ID!) {
    ticketMessages(ticketId: $ticketId) { id body authorKind authorName createdAt }
  }
`;

export const CREATE_WIDGET_TICKET = `
  mutation CreateWidgetTicket($input: CreateWidgetTicketInput!) {
    createWidgetTicket(input: $input) { id number title status lastMessageAt unread }
  }
`;

export const SEND_WIDGET_MESSAGE = `
  mutation SendWidgetMessage($input: SendWidgetMessageInput!) {
    sendWidgetMessage(input: $input) {
      id body authorKind authorName createdAt
      attachments { id name mimeType size }
    }
  }
`;

/** `SEND_WIDGET_MESSAGE` as the API knew it before attachments — see `compat.ts`. */
export const SEND_WIDGET_MESSAGE_WITHOUT_ATTACHMENTS = `
  mutation SendWidgetMessage($input: SendWidgetMessageInput!) {
    sendWidgetMessage(input: $input) { id body authorKind authorName createdAt }
  }
`;

export const CREATE_WIDGET_UPLOAD = `
  mutation CreateWidgetUpload($input: CreateWidgetUploadInput!) {
    createWidgetUpload(input: $input) { fileId uploadUrl }
  }
`;

export const TICKET_ATTACHMENT = `
  query TicketAttachment($ticketId: ID!, $fileId: ID!) {
    ticketAttachment(ticketId: $ticketId, fileId: $fileId) { url expiresInSeconds }
  }
`;

export const MARK_WIDGET_TICKET_READ = `
  mutation MarkWidgetTicketRead($input: MarkWidgetTicketReadInput!) {
    markWidgetTicketRead(input: $input)
  }
`;
